module.exports = __webpack_public_path__ + "static/img/img-3.3a2ba29.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-3.png
// module id = 4LLr
// module chunks = 1